import * as React from "react"
import * as $ from "jquery";
import { APP_STYLE_CONSTANTS, ORION_IMG_URL } from "../utils/AppConstants";
import AppUtils from "../utils/AppUtils";

/*
 * Created by Prachi on 21/03/18.
 * Collapsible Panel Component
 * Note : 1st child is panel header ie., this.props.children[0] is header
 * Note : 2nd child is panel body ie., this.props.children[1] is body
 */
export interface CollapsiblePanelProps {
    children: {[index: number]: any};
    handleClick?: (e: any) => void;
    className?: string
}

export default class CollapsiblePanel extends React.Component<CollapsiblePanelProps> {
    toggleCardView = function(evt: any, isHide?: boolean): void{
        let collapsibleCard = $(evt.target).closest(".collapsible-panel");
        collapsibleCard.toggleClass("active-collapsible-panel");
        collapsibleCard.find(".collapsible-panel-btn").toggleClass("rotated");
        if (isHide) {
            let topPosition = collapsibleCard[0].offsetTop - APP_STYLE_CONSTANTS.APP_NAV - APP_STYLE_CONSTANTS.TABS_NAV;
            $(".ongoing-consultation-main-cont").animate({ scrollTop: topPosition }, { duration: 500, complete: function() {collapsibleCard.find(".collapsible-panel-body").slideToggle()} } );
        } else {
            collapsibleCard.find(".collapsible-panel-body").slideToggle();
        }
        // evt.stopPropagation();
    };

    handlePanelClick = (e: any) => {
        const hasClickHandler = AppUtils.isDefined(this.props.handleClick) && typeof this.props.handleClick === "function";
        if (hasClickHandler) this.props.handleClick(e);
    }

    render() {
        return (
            <div className={`collapsible-panel-container ${this.props.className || ""}`} onClick={this.handlePanelClick}>
                <div className="collapsible-panel">
                    <div className="collapsible-header" onClick={event => this.toggleCardView(event)}>
                        <div className="collapsible-panel-btn in-blk mid-align pull-right">
                            <img src={ORION_IMG_URL + "icons/down-arrow.svg"}/>
                        </div>
                        {this.props.children[0]}
                    </div>
                    <div className="collapsible-panel-body">
                        {this.props.children[1]}
                        <div className={"hide-panel"}><a onClick={event => this.toggleCardView(event, true)}>Hide</a></div>
                    </div>
                </div>
            </div>
        );
    }
}

